<template>
<v-list-item >
  <!-- <pre v-text='settings' /> -->
  <v-list-item-avatar >
    <img
      v-if='logoPicture(value)'
      :src='logoPicture(value)' />
    <v-icon v-else >mdi-camera-picture</v-icon>
  </v-list-item-avatar>
  <v-list-item-content>
    <v-list-item-title>
      {{ settings.practice_name }}. <small>{{ settings.practice_number }}</small>
    </v-list-item-title>
    <template v-if='settings' >
      <v-list-item-subtitle>
        {{ settings.billing_address }}
      </v-list-item-subtitle>
      <v-list-item-subtitle>
        {{ settings.banking_details }}
      </v-list-item-subtitle>
    </template>
  </v-list-item-content>
  <slot name='action' >
  </slot>
</v-list-item>
</template>
<script>
export default {
  name: 'Settings',
  props: {
    value: { type: Object, required: true }
  },
  computed: {
    settings () {
      let s = this.getObjectPath(this.value, 'settings')
      if (!s) { s = this.getObjectPath(this.value, 'invoice_settings') }
      if (!s) { s = this.getObjectPath(this.value, 'profile') }
      if (!s) { s = this.value }
      return s
    }
  }
}
</script>
